import React from "react";
import "../../../../css/AreaGobierno/tribunal-de-cuentas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

const resoluciones = [
  {
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/tribunal-cuentas/resolucion/Resolucion-1-2020-Reglamento-Interno.pdf",
    text: "RESOLUCIÓN 01/2020"
  }
  // Puedes agregar más resoluciones aquí si las tienes
];

const ResolucionesTribunal = () => (
  <div className="memorias-tribunal-bg">
    <div className="memorias-tribunal-container">
      <h1>RESOLUCIONES TRIBUNAL DE CUENTAS</h1>
      <div className="row justify-content-center">
        {resoluciones.map((resol, idx) => (
          <div className="col-md-4 col-sm-6 col-12 mb-4 d-flex align-items-stretch" key={idx}>
            <a
              href={resol.url}
              target="_blank"
              rel="noopener noreferrer"
              className="memoria-btn w-100 d-flex flex-row align-items-center justify-content-center"
            >
              <span className="memoria-btn-icon me-2">
                <FontAwesomeIcon icon={faPaperclip} />
              </span>
              <span className="memoria-btn-text text-center">{resol.text}</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ResolucionesTribunal;